import { store } from '@atredux/store'
import { getStoreId } from '@atredux/selectors/storeSelector'
import { getPreviousTool } from '@atredux/selectors/toolSelector'
import { setSelectedStoreId, setStoreScanStatus } from '@atredux/slices/storeSlice'
import { _navigateToTool } from '@src/components/SideBar/utils/SideBarUtil'

export async function backToPreviousStoreListener (message: any) {
    const state = store.getState()
    const currentStoreId = getStoreId(state)
    const previousTool = getPreviousTool(state)

    if (!previousTool) {
        return Promise.reject('No previous tool available')
    }

    store.dispatch(setSelectedStoreId(undefined))
    store.dispatch(setStoreScanStatus({ storeId: currentStoreId, scanned: true }))
    _navigateToTool(previousTool)

    return Promise.resolve()
}
